import { createSlice } from '@reduxjs/toolkit';

const totalCountSlice = createSlice({
    name: 'totalCount',
    initialState: 0,
    reducers: {
        setTotalCount: (state, action) => action.payload,
    },
});

export const { setTotalCount } = totalCountSlice.actions;

export default totalCountSlice.reducer;
